import { createRoot } from 'react-dom/client'
import './index.css'
import './sentry'
import { App } from './app'

const root = createRoot(document.getElementById('app') as HTMLDivElement)
root.render(<App />)
